import {Repository} from '@s-ui/domain'

export class NewsBookmarksRepository extends Repository {
  save() {
    throw new Error('[NewsBookmarksRepository#save] must be implemented')
  }

  delete() {
    throw new Error('[NewsBookmarksRepository#delete] must be implemented')
  }

  getSavedIds() {
    throw new Error('[NewsBookmarksRepository#getSavedIds] must be implemented')
  }
}
